import { DomainPortal } from './domain-portal';

export class DomainPortalSerializer {

  fromJson(json: any): DomainPortal {
    const domain = new DomainPortal();
    if (typeof json.success !== 'undefined' && typeof json.data !== 'undefined') {
      domain.success = json.success;
      domain.data = json.data;
      return domain;
    } else {
      domain.id = json.id;
      domain.option_domain = json.option_domain;
      domain.system_domain = json.system_domain;
      domain.client_domain = json.client_domain;
      domain.scopeChangeSettings = json.scopeChangeSettings;
      domain.last_change = json.last_change;
      domain.changed_by = json.changed_by;
      domain.CNAME = json.CNAME;
      domain.front_url = json.front_url;
      return domain;
    }
  }

  toJson(domain: DomainPortal): any {
    return {
      id: domain.id,
      option_domain: domain.option_domain,
      system_domain: domain.system_domain,
      client_domain: domain.client_domain,
      CNAME: domain.CNAME,
      front_url: domain.front_url,
    };
  }
}
